import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';
import webClient from '../../core/web_client';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { PRODUCTS_AVAILABILITY_PATH } from '../../core/constants';

export const deleteProductAvailabilityAction = createAsyncThunk(
    'reservation/deleteProductAvailabilityAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.delete(PRODUCTS_AVAILABILITY_PATH, { data });
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const deleteProductAvailabilitySlice = createSlice({
    name: 'deleteProductAvailabilitySlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(deleteProductAvailabilityAction.pending, () => STATE__API__STARTED);
        builder.addCase(deleteProductAvailabilityAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(deleteProductAvailabilityAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const deleteProductAvailabilityState = (state) => state.reservation.deleteProductAvailability;
export default deleteProductAvailabilitySlice.reducer;
